import logo from "../assets/images/logo.png";

export const Logo = ({ className }) => {
  return (
    <img
      src={logo}
      alt="logo"
      className={className + "object-contain object-center mx-auto "}
    />
  );
};
